<template>

    <CascoAjanlatBase :titleExtra="titleExtra">

        <v-form slot="biztositoi-adatok" ref="casco-ajanlat-adatok">

            <v-layout row wrap>

                <BnFormField v-if="szabAtvetelLatszik()" :attributes="aegon_szabatvetel_mod"/>

                <BnFormField v-if="szemleLatszik()" :attributes="aegon_szemle"/>

                <BnFormField v-if="extraVisible()" :attributes="aegon_extrak_felsorolas"/>

                <BnFormField v-if="megszunesOkVisible()" :attributes="aegon_casco_elozoszerzodes_megszunes"/>

                <BnFormField v-if="elozoRendszamVisible()" :attributes="ajanl_rendszam"/>

                <BnFormField v-if="alfaCascoKotesiOkVisible()" :attributes="alfa_casco_kotesi_ok"/>

                <BnFormField v-if="cascoPartnerSzerzodesszamVisible()" :attributes="casco_partner_szerzodesszam"/>

                <BnFormField v-if="gfbRendezettKarokDbVisible()" :attributes="gfb_rendezett_karok_db"/>

                <BnFormField v-if="cascoRendezettKarokDbVisible()" :attributes="casco_rendezett_karok_db"/>

                <BnFormField v-if="biztositoNemRendezettEsemenyDbVisible()" :attributes="biztosito_nem_rendezett_esemeny_db"/>

                <BnFormField v-if="lopaskarDbVisible()" :attributes="lopaskar_db"/>

            </v-layout>

        </v-form>

    </CascoAjanlatBase>

</template>

<script>
import BnFormField from '../../../../../../../basecomponents/BnFormField.vue';
import modozat from '../../../../../mixins/modozat';
import CascoAjanlatBase from '../CascoAjanlatBase.vue';
import cascoOfferData from '../../../../../mixins/ajanlatiadatok/biztosito_specifikus/CascoOfferData';
import { AEGON } from '../../../../../../../../modules/Biztosito';
import DateFormat from '../../../../../../../../utils/DateFormat';

export default {
    components: {CascoAjanlatBase, BnFormField},
    mixins: [cascoOfferData, modozat],
    methods: {
        extraVisible() {
            return parseInt(this.$store.getters.tarifaData.aegon_extrak_osszertek, 10) > 0;
        },
        szabAtvetelLatszik() {
            return this.valasztottKgfbBiztosito !== AEGON && !this.$store.getters.isOvb;
        },
        szemleLatszik() {
            return !this.$store.getters.isOvb && !this.isUjForgalombaHelyezes;
        },
        szabatvetelChange() {
            this.szabatvetel = this.$store.getters.tarifaData.aegon_szabatvetel_mod;
        },
        elozoRendszamVisible() {
            return this.$store.getters.vanCascoBonusz
                && this.$store.getters.tarifaData.casco_evfordulos !== 'Y';
        },
        alfaCascoKotesiOkVisible() {
            return !this.isRendszamNelkuliMotor && !this.isEvfordulosMotor;
        },
        megszunesOkVisible() {
            return this.$store.getters.vanCascoBonusz;
        },
        cascoPartnerSzerzodesszamVisible() {
          return this.kedvezmenyek.partner === true;
        },
        gfbRendezettKarokDbVisible() {
            return this.$store.getters.isMotorCasco;
        },
        cascoRendezettKarokDbVisible() {
            return this.$store.getters.isMotorCasco;
        },
        biztositoNemRendezettEsemenyDbVisible() {
            return this.$store.getters.isMotorCasco;
        },
        lopaskarDbVisible() {
            return this.$store.getters.isMotorCasco;
        },
        setCascoKotesiOkAlapErtek() {
            let value = null;
            if (this.isRendszamNelkuliMotor) value = '7'; // Új forgalomba helyezés
            else if (this.isEvfordulosMotor) value = '3'; // Évfordulós biztosítóváltás

            if (value == null) return;

            this.$store.commit('setProp', {
                path: 'tarifaData.alfa_casco_kotesi_ok',
                value,
            });
        }
    },
    computed: {
        valasztottKgfbBiztosito() {
            return this.$store.getters.valasztottKgfbBiztosito;
        },
        isRendszamNelkuliMotor() {
            return this.$store.getters.isMotor
                && this.$store.getters.gepjarmu.nincsrendszam;
        },
        isEvfordulosMotor() {
            return this.$store.getters.isMotor
                && this.$store.getters.tarifaData.casco_evfordulos === 'Y';
        },
        isUjForgalombaHelyezes() {
            const forgDatum = this.$store.getters.gepjarmu.mo_forgh_datum
                ? new Date(DateFormat.plainToDashed(this.$store.getters.gepjarmu.mo_forgh_datum))
                : null;

            if (forgDatum === null) return false;

            const kockkezd = this.$store.getters.tarifaData.kock_kezd_casco
                ? new Date(DateFormat.plainToDashed(this.$store.getters.tarifaData.kock_kezd_casco))
                : null;

            if (kockkezd === null) return false;

            const isUjForgalombaHelyezes = +this.$store.getters.gepjarmu.kmallas < 100
                && +this.$store.getters.gepjarmu.gyartev >= (new Date().getFullYear() - 1)
                && Math.floor((kockkezd - forgDatum) / (1000 * 60 * 60 * 24)) < 15;

            return this.vanCasco && isUjForgalombaHelyezes;
        },
    },
    mounted() {
        this.szabatvetel = this.$store.getters.tarifaData.aegon_szabatvetel_mod;
        if (this.$store.getters.tarifaData.alfa_casco_kotesi_ok == null) this.setCascoKotesiOkAlapErtek();
    },
    data() {
        return {
            AEGON,
            name: 'AjanlatAdatokB3_V0',
            version: 'v0',
            szabatvetel: '',
            aegon_szabatvetel_mod: {
                type: 'select',
                label: 'Szabályzat átvételi mód',
                visible: true,
                editable: true,
                help: true,
                mezo: 'aegon_szabatvetel_mod',
                path: 'tarifaData.aegon_szabatvetel_mod',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    {key: 'M', value: 'Email küldés (letöltés internetről)'},
                    {key: 'N', value: 'Nyomtatás szabályzattal együtt'},
                    {key: 'C', value: 'Nyomtatás és Nyomdai szabályzat'},
                ],
                change: this.szabatvetelChange,
            },
            aegon_szemle: {
                type: 'select',
                label: 'Szemle módja',
                visible: true,
                editable: true,
                help: true,
                mezo: 'aegon_szemle',
                path: 'tarifaData.aegon_szemle',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    {key: 'A', value: 'Alkuszi szemle'},
                    {key: 'B', value: 'Biztosítói szemle'},
                ],
            },
            aegon_extrak_felsorolas: {
                type: 'text',
                label: 'Szérián kívüli extrák felsorolása',
                visible: true,
                editable: true,
                help: true,
                mezo: 'aegon_extrak_felsorolas',
                path: 'tarifaData.aegon_extrak_felsorolas',
            },
            ajanl_rendszam: {
                type: 'text',
                label: 'CASCO előzményszerződéshez tartózó gépjármű rendszáma',
                visible: true,
                editable: true,
                mezo: 'ajanl_rendszam',
                path: 'tarifaData.ajanl_rendszam',
                help: true,
                mask: 'GGGGGGGGG',
            },
            aegon_casco_elozoszerzodes_megszunes: {
                type: 'select',
                label: 'Casco előzőszerződés megszűnés oka',
                visible: true,
                editable: true,
                help: true,
                mezo: 'aegon_casco_elozoszerzodes_megszunes',
                path: 'tarifaData.aegon_casco_elozoszerzodes_megszunes',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    {key: 61, value: 'Átdolgozás miatt törölt szerződés'},
                    {key: 63, value: 'Díjnemfizetés'},
                    {key: 67, value: 'Érdekmúlás eladás miatt'},
                    {key: 68, value: 'Érdekmúlás megsemmisülés miatt'},
                    {key: 70, value: 'Felmondás az ügyfél részéről'},
                    {key: 71, value: 'Felmondás a biztosító részéről'},
                    {key: 72, value: 'Érdekmúlás eltulajdonítás (lopás) miatt'},
                    {key: 74, value: 'Végleges forgalomból kivonás'},
                ],
            },
            alfa_casco_kotesi_ok: {
                type: 'select',
                label: 'Casco szerződéskötés oka',
                visible: true,
                editable: true,
                help: true,
                mezo: 'alfa_casco_kotesi_ok',
                path: 'tarifaData.alfa_casco_kotesi_ok',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    {key: '1', value: 'Tulajdonos váltás'},
                    {key: '2', value: 'Dnf. miatti újrakötés'},
                    {key: '3', value: 'Évfordulós biztosítóváltás'},
                    {key: '4', value: 'Közös megegyezés'},
                    {key: '5', value: 'Üzembentartó váltás'},
                    {key: '6', value: 'Öröklés jogerős hagyatéki alapján'},
                    {key: '7', value: 'Új forgalomba helyezés'},
                    {key: '9', value: 'Egyéb'},
                ],
            },
            casco_partner_szerzodesszam: {
                type: 'text',
                label: 'Partner kedvezmény azonosító',
                visible: true,
                editable: true,
                mezo: 'casco_partner_szerzodesszam',
                path: 'tarifaData.casco_partner_szerzodesszam',
                help: true,
            },
            gfb_rendezett_karok_db: {
                type: 'select',
                label: 'Korábban GFB alapján rendezett károk darabszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'gfb_rendezett_karok_db',
                path: 'tarifaData.gfb_rendezett_karok_db',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    {key: '0', value: '0'},
                    {key: '1', value: '1'},
                    {key: '2', value: '2'},
                    {key: '3', value: '3 vagy több'},
                ],
            },
            casco_rendezett_karok_db: {
                type: 'select',
                label: 'Korábban CASCO alapján rendezett károk darabszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'casco_rendezett_karok_db',
                path: 'tarifaData.casco_rendezett_karok_db',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    {key: '0', value: '0'},
                    {key: '1', value: '1'},
                    {key: '2', value: '2'},
                    {key: '3', value: '3 vagy több'},
                ],
            },
            biztosito_nem_rendezett_esemeny_db: {
                type: 'select',
                label: 'Korábbi biztosító által nem rendezett esemény darabszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'biztosito_nem_rendezett_esemeny_db',
                path: 'tarifaData.biztosito_nem_rendezett_esemeny_db',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    {key: '0', value: '0'},
                    {key: '1', value: '1'},
                    {key: '2', value: '2'},
                    {key: '3', value: '3 vagy több'},
                ],
            },
            lopaskar_db: {
                type: 'select',
                label: 'Korábbi teljes gépkocsi lopáskár darabszáma',
                visible: true,
                editable: true,
                help: true,
                mezo: 'lopaskar_db',
                path: 'tarifaData.lopaskar_db',
                itemsText: 'value',
                itemsValue: 'key',
                options: [
                    {key: '0', value: '0'},
                    {key: '1', value: '1'},
                    {key: '2', value: '2'},
                    {key: '3', value: '3 vagy több'},
                ],
            },
        };
    },
};
</script>
